// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Benefit_wrapper__BnTXl","icon":"Benefit_icon__HrHXR","details":"Benefit_details__P4H7_"};